<template>
	<v-container>
		<v-app-bar app color="blue">
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title class="white--text">
				<span class="d-none d-sm-inline" v-if="emenda && emenda.id">Detalhes da </span>
				<!-- <span class="d-none d-sm-inline" v-else>Nova </span> -->
				Emenda
			</v-toolbar-title>
			<template v-slot:extension v-if="!!(emenda && emenda.id)">
				<v-tabs v-model="tab" centered dark icons-and-text>
					<v-tabs-slider></v-tabs-slider>

					<v-tab href="#tabGeral">
						Geral
						<v-icon>mdi-cash-lock</v-icon>
					</v-tab>

					<v-tab href="#tabDotacoes">
						Dotações
						<v-icon>mdi-cash-multiple</v-icon>
					</v-tab>

					<v-tab href="#tabProcessos" style="line-height: 1">
						<span>Eletrônico</span>
						<span>Processo</span>
						<v-icon>mdi-cash-multiple</v-icon>
					</v-tab>

					<v-tab href="#tabCpl" style="line-height: 1">
						<span>Físico</span>
						<span>Processo</span>
						<v-icon>mdi-cash-multiple</v-icon>
					</v-tab>

					<!-- <v-tab href="#tabDespachos">
						Despachos
						<v-icon>mdi-cash</v-icon>
					</v-tab> -->

				</v-tabs>
			</template>
		</v-app-bar>

		<v-card tile>
			<v-container>
				<!-- :read-only="formDesativado" -->
				<v-emenda-form
					v-model="emenda"
					:tab="tab"
					@salvando="v => (salvarLoading = v)"
					@removendo="v => (removerLoading = v)"
					@saved="salvo"
					@updated="salvo"
					ref="emendaForm"
					:read-only=true
					@snack="v => this.$emit('snack',v)"
					@atualizar="atualizarEmenda"
				/>
				<!-- <v-row>
					<v-col justify-end width="100%">
						<v-btn color="primary" class="mr-5" @click="exibirTramitar()" v-if="emenda && emenda.id">Tramitar</v-btn>
					</v-col>
					
					<v-col class="text-right" justify-end width="100%">
						<v-btn text class="mr-5" @click="cancelar">Cancelar</v-btn>
						<v-dialog
							v-model="dialog"
							persistent
							max-width="350"
							v-if="tab == 'tabGeral'"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									class="mr-5"
									color="error"
									:loading="removerLoading"
									:disabled="removerLoading || formDesativado"
									@click="removerEmenda"
									v-bind="attrs"
									v-on="on"
									
								>
									Remover
								</v-btn>
							</template>
							<v-card>
								<v-card-title class="headline">
									Voce tem certeza disso?
								</v-card-title>
								<v-card-text v-if="emenda">
									<p>
										Você confirma a exclusão da emenda
										{{ emenda.numeroEmenda }} de {{ emenda.anoExercicio }}?
									</p>
									<p>{{ emenda.descricao }}</p>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn text @click="cancelarRemocao">
										Cancelar
									</v-btn>
									<v-btn color="error" text @click="confirmarRemocao">
										Confirmar
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
						<v-btn
							color="primary"
							:loading="salvarLoading"
							:disabled="salvarLoading || formDesativado"
							@click="salvarEmenda"
						>
							Salvar
						</v-btn>
					</v-col>
				</v-row> -->
			</v-container>
		</v-card>
	</v-container>
</template>

<script>
import VEmendaForm from '@/forms/EmendaForm.vue';
import { Vue } from '@/main';

export default {
	components: { VEmendaForm },
	data() {
		return {
			emenda: null,
			salvarLoading: false,
			removerLoading: false,
			dialog: false,
			tab: 'tabGeral'
		};
	},
	computed: {
		emendaForm() {
			let ComponentClass = Vue.extend(VEmendaForm);
			let emendaForm = new ComponentClass();
			if (this.emenda && this.$refs && this.$refs.emendaForm) {
				return this.$refs.emendaForm;
			} else {
				return emendaForm;
			}
		},
		formDesativado() {
			if (this.$root.usuarioLogado &&
					this.$root.usuarioLogado.funcoes &&
					this.$root.usuarioLogado.funcoes.includes('EMENDA_ALTERAR')) {
				return false;
			// } else if (this.emenda && this.emenda.emendaSituacao && this.emenda.emendaSituacao.id === 3) {
			// 	return false;
			} else {
				return true;
			}
		}
	},
	async created() {
		if (this.$route.params.id !== 'novo') {
			this.emenda = await this.emendaForm.obterEmenda(this.$route.params.id);
		}
	},
	methods: {
		async salvarEmenda() {
			await this.emendaForm.salvar();
		},

		exibirTramitar() {
			this.emendaForm.exibirTramitar();
		},
		
		async removerEmenda() {
			this.dialog = true;
		},

		cancelar() {
			this.$router.replace('/emendas');
		},
		async confirmarRemocao() {
			let emendaRemovida = await this.emendaForm.remover();
			if (emendaRemovida && emendaRemovida.id) {
				this.$emit('snack', {
					show: true,
					text: `Emenda ${emendaRemovida.numeroEmenda} removida com sucesso`
				});
				this.$router.replace('/emendas');
			}
			this.dialog = false;
		},
		cancelarRemocao() {
			this.dialog = false;
		},

		salvo(emendaSalva, tipo) {

			if (emendaSalva && emendaSalva.id) {
				this.$emit('snack', {
					show: true,
					text: `Emenda ${emendaSalva.numeroEmenda} salva com sucesso`
				});

				//this.$router.replace('/emendas');
			}
				
			if (tipo == 'update') {
				this.$router.replace('/emendas');
			}
			else {
				this.$route.params.id = emendaSalva.id;
				this.atualizarEmenda();
			}
		},

		async atualizarEmenda() {
			if (this.$route.params.id !== 'novo') {
				this.emenda = await this.emendaForm.obterEmenda(this.$route.params.id);
			}
		}

	}
};
</script>
